export default "__VITE_ASSET__BPMeoXAc__"